export const homeContentLinksWithHealthPlanFormatter = (links, data = {}) => {
  return links.map((link) => {
    return link.key === 'HEALTHPLANS'
      ? {
          ...link,
          href: data.stateHealthPlanLink ? data.stateHealthPlanLink : link.href,
          name: data.formattedStateName || 'Health plan',
        }
      : link;
  });
};
